module.exports = __webpack_public_path__ + "static/media/table.494dd63d.jpg";